/**
 * Full-page loading spinner — displayed during page transitions
 */

interface PageLoaderProps {
  /** Optional loading text message */
  message?: string
  /** Optional size variant */
  size?: 'sm' | 'md' | 'lg'
}

export function PageLoader({ message = 'Loading…', size = 'md' }: PageLoaderProps) {
  const sizeClasses = {
    sm: 'h-6 w-6',
    md: 'h-8 w-8',
    lg: 'h-12 w-12',
  }

  const textSizeClasses = {
    sm: 'text-xs',
    md: 'text-sm',
    lg: 'text-base',
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-white">
      <div className="flex flex-col items-center gap-3">
        <div className="flex items-center justify-center">
          <svg
            className={`animate-spin text-blue-600 ${sizeClasses[size]}`}
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
          </svg>
        </div>
        {message && <p className={`font-medium text-gray-600 ${textSizeClasses[size]}`}>{message}</p>}
      </div>
    </div>
  )
}

export default PageLoader
